import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Lock, List, Settings, Tv, UserCog } from "../components/icons";

export default function AdminDashboard() {
  const { t } = useTranslation("admin");

  const managementCards = [
    {
      id: "users",
      title: t("userManagement"),
      description: t("usersCardDescription"),
      icon: UserCog,
      color: "bg-primary-600",
      hoverColor: "hover:bg-primary-700",
      path: "/admin/users",
    },
    {
      id: "ai-settings",
      title: t("aiSettings.navTitle"),
      description: t("aiSettings.navDescription"),
      icon: Settings,
      color: "bg-violet-600",
      hoverColor: "hover:bg-violet-700",
      path: "/admin/ai-settings",
    },
    {
      id: "reference-data",
      title: t("referenceData.navTitle"),
      description: t("referenceData.navDescription"),
      icon: List,
      color: "bg-teal-600",
      hoverColor: "hover:bg-teal-700",
      path: "/admin/reference-data",
    },
    {
      id: "share-settings",
      title: t("shareSettings.navTitle"),
      description: t("shareSettings.navDescription"),
      icon: Lock,
      color: "bg-amber-600",
      hoverColor: "hover:bg-amber-700",
      path: "/admin/share-settings",
    },
    {
      id: "broadcasters",
      title: t("broadcasters.navTitle"),
      description: t("broadcasters.navDescription"),
      icon: Tv,
      color: "bg-sky-600",
      hoverColor: "hover:bg-sky-700",
      path: "/admin/broadcasters",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-6 sm:px-6 lg:px-8">
          <h1
            className="text-3xl font-bold text-gray-900"
            data-testid="admin-dashboard-heading"
          >
            {t("dashboard")}
          </h1>
          <p className="mt-2 text-sm text-gray-500">{t("dashboardSubtitle")}</p>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">
            {t("administrationSectionTitle")}
          </h2>
          <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
            data-testid="admin-management-section"
          >
            {managementCards.map((card) => {
              const Icon = card.icon;
              return (
                <Link
                  key={card.id}
                  to={card.path}
                  data-testid={`admin-card-${card.id}`}
                  className="rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-all duration-200 p-6 text-left group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
                >
                  <div className="flex items-start gap-4">
                    <div
                      className={`flex-shrink-0 ${card.color} ${card.hoverColor} rounded-lg p-3 transition-colors`}
                    >
                      <Icon className="h-8 w-8 text-white" aria-hidden="true" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="text-lg font-semibold text-gray-900 mb-1">
                        {card.title}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {card.description}
                      </p>
                    </div>
                  </div>
                  <div className="mt-4 flex items-center text-sm font-medium text-gray-500 group-hover:text-gray-700">
                    {t("manage")}
                    <svg
                      className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </main>
    </div>
  );
}
